module.exports = __webpack_public_path__ + "media/images/recipes/zalmmoot_zalmfilet-d0321ce78e87ae3c937499e8b544997b.pdf";